export const EmptyValue = () => {
  return <span className="sb-grid-empty-value opacity-50">EMPTY</span>
}
